import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import WhistleblowingRegulation from 'components/whistleblowing-regulation';

type Props = {
  data: Object,
};

const WhistleblowingRegulationPage = ({ data }: Props) => {
  const {
    whistleblowingRegulationJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...whistleblowingRegulationJson,
        menu: siteJson?.content,
        cookieConsent: cookieConsentJson,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <WhistleblowingRegulation />
      </Layout>
    </Website>
  );
};

export default WhistleblowingRegulationPage;

export const query = graphql`
  query WhistleblowingRegulationPageQuery {
    whistleblowingRegulationJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      statements {
        tabs {
          id
          label
          title
          text
        }
      }
      meta {
        description
        title
      }
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
